import React, { useState } from 'react';
import { 
  Text, 
  View, 
  StyleSheet, 
  TouchableOpacity, 
  ScrollView, 
  ActivityIndicator 
} from 'react-native';
import Dropzone from 'react-dropzone';
import { httpUpload } from '../../helpers/ajaxHelper';
import Urls from '../../services/Urls';
import { MaterialIcons } from '@expo/vector-icons';

const FilePicker = ({
  loading,
  files,
  onFileSelect,
  Idindex,
  onDataSuccess,
  accept,
  onDelete,
}) => {

  const [uploading, setUploading] = useState(false);

  const isLoading = loading || uploading;

  const onDropImages = (data) => {
    if (data && data.length) {
      setUploading(true);

      const newImages = data.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      );

      const formdata = new FormData();
      formdata.append('type', 'Document');
      newImages.forEach((item) => formdata.append('files', item));

      httpUpload
        .post(Urls.Upload, formdata)
        .then(({ data }) => {
          if (data.status) {
            onDataSuccess(data?.data);
          }
        })
        .catch((error) => console.log('error', error))
        .finally(() => {
          setUploading(false);
        });
    }
  };

  return (
    <>
      <Dropzone
        disabled={isLoading}
        accept={
          accept ||
          'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.tsv,.ppt,.pptx,.pages,.odt,.rtf'
        }
        onDrop={onDropImages}
        onDropRejected={() => alert('Invalid File')}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps()}
            style={{
              width: "100%",
              minHeight: 120,
              border: '2px dashed #ccc',
              borderRadius: 12,
              backgroundColor: isLoading ? '#f0f0f0' : '#fdfdfd',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.7 : 1,
            }}
          >
            <input {...getInputProps()} />

            {isLoading ? (
              <View style={{ alignItems: 'center' }}>
                <ActivityIndicator size="large" color="#007bff" />
                <Text style={{ marginTop: 8, color: '#555' }}>
                  Uploading...
                </Text>
              </View>
            ) : (
              <Text style={{ textAlign: 'center', color: '#555', fontSize: 14 }}>
                Drag & drop files here or{' '}
                <Text style={{ color: '#007bff', fontWeight: 'bold' }}>
                  click to select
                </Text>
              </Text>
            )}
          </div>
        )}
      </Dropzone>

      <ScrollView style={{ marginTop: 10 }}>
        {files?.length > 0 &&
          files.map((file, index) => (
            <View key={index} style={styles.fileContainer}>
              <View style={styles.iconBox}>
                <MaterialIcons name="insert-drive-file" size={22} color="#555" />
              </View>

              <Text numberOfLines={1} style={styles.fileText}>
                {file?.name}
              </Text>

              <TouchableOpacity 
                onPress={() => onDelete(index)} 
                style={styles.deleteBtn}
                disabled={isLoading}
              >
                <MaterialIcons name="delete" size={20} color="#ff4d4f" />
              </TouchableOpacity>
            </View>
          ))}
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  fileContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 10,
    marginBottom: 8,
    marginHorizontal: 2,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    width: 300
  },
  iconBox: {
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: '#e0e0e0',
    marginRight: 10,
  },
  fileText: {
    flex: 1,
    fontSize: 14,
    color: '#333',
  },
  deleteBtn: {
    marginLeft: 10,
    padding: 4,
  },
});

export default FilePicker;
